module.exports = __webpack_public_path__ + "img/loginYGS.d8275f5e.png";